/**
 * Canonical TAZZIEDEVIL2.0 / DREADCORE brand visuals.
 * ALIGNED WITH SOVEREIGN PAINTERLY ENGINE OUTPUTS.
 */
export const TAZZIE_BRAND_VISUALS = {
  // Core platform / OS
  dreadcoreSi: '/assets/symphonic-defender.png',
  tazzieEmblem: '/assets/symphonic-defender.jpeg',
  tazPhoto: '/assets/anchor-against-rest.jpeg',
  tazChip: '/assets/Anchor%20Logo.jpeg',

  // Cast / character lockups
  castLockup: '/assets/symphonic-defender.png',
  dreadcoreCastAvatar: '/assets/tazzie-network/dreadcore_cast_avatar.png',
  
  // Fallback character assets. Production art must meet
  // docs/tazzie/CHARACTER_ART_MINIMUM_STANDARD.md before being called canonical.
  tazzieCharacter: '/assets/cast/char_tazzie_devil.png',
  bunjiCharacter: '/assets/cast/char_bunji.png',
  winstonCharacter: '/assets/cast/char_winston.png',
  kiraCharacter: '/assets/cast/char_kira.png',
  musaCharacter: '/assets/cast/char_musa.png',
  amiraCharacter: '/assets/cast/char_amira.png',
  dreadcoreAnchor: '/assets/cast/char_news_anchor.png',
  tazziedevil2Anchor: '/assets/cast/char_tazzie_devil.png',
  marnieCharacter: '/assets/cast/char_marnie.png',
  mamaCharacter: '/assets/cast/char_mumma_arazi.png',
  babaCharacter: '/assets/cast/char_baba_taha.png',
  babyCharacter: '/assets/cast/char_baby_mohammed.png',
  captainCoralCharacter: '/assets/cast/char_captain_coral.png',
  professorPlatyCharacter: '/assets/cast/char_professor_platy.png',
  nurseKoalaCharacter: '/assets/cast/char_nurse_koala.png',
  sparkyCharacter: '/assets/cast/char_sparky.png',
  coachRooCharacter: '/assets/cast/char_coach_koa.png',
  djWombatCharacter: '/assets/cast/char_dj_wombat.png',
  
  // Expanded Series Cast
  nyxCharacter: '/assets/cast/char_nyx.png',
  cipherCharacter: '/assets/cast/char_cipher.png',
  ravenCharacter: '/assets/cast/char_raven.png',
  ghostCharacter: '/assets/cast/char_ghost.png',
  sparksCharacter: '/assets/cast/char_sparks.png',
  drAmaraCharacter: '/assets/cast/char_dr_amara_osei.png',
  drYunCharacter: '/assets/cast/char_dr_yun.png',
  kraalCharacter: '/assets/cast/char_kraal.png',
  didgeCharacter: '/assets/cast/char_didge.png',
  reporterCharacter: '/assets/cast/char_field_reporter.png',

  // Epic backgrounds
  symphonicIntelligenceHero: '/assets/anchor-brand-bg.jpeg',
  anchorMarketingGrowthHero: '/assets/anchor-gov-bg.jpeg',
  dreadcoreGodTestMode: '/assets/tazzie-network/dreadcore-god-test-mode.svg',
  anchorNeonLogo: '/assets/Anchor%20Logo.jpeg',
  anchorBrandBg: '/assets/anchor-brand-bg.jpeg',
  chatBotComparison: '/assets/App%20store%20image.jpeg',
  tazziedevil2: '/assets/symphonic-defender.png',
  tazzieWorld: '/assets/anchor-brand-bg.jpeg',
  loginScreenBackground: '/assets/screen%20back%20ground.jpeg',

  // TAZZIE Network media
  tazzieNetworkEmblem: '/assets/logos/tazzie-emblem.png',
  musaAmira: '/assets/tazzie-network/musa-amira.png',
  tazzieNetworkDreadcoreSi: '/assets/tazzie-network/dreadcore-si.svg',
  antikytheraBlueprint: '/assets/tazzie-network/antikythera-blueprint.svg',
  flowerOfLifeBlueprint: '/assets/tazzie-network/flower-of-life-blueprint.svg',
} as const;

export type TazzieBrandVisualKey = keyof typeof TAZZIE_BRAND_VISUALS;

export function cssUrl(key: TazzieBrandVisualKey): string {
  const path = TAZZIE_BRAND_VISUALS[key];
  return `url("${path}")`;
}
